//Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from "../config";

//Components
import HeroImage from "./HeroImage";
import Grid from "./Grid";
import Thumb from "./Thumb";
import Spinner from "./Spinner";
import Button from "./Button";
import SearchBar from "./SearchBar";
import ErrorHandler from "./ErrorHandler";

//Hooks
import { useMoviesFetch } from "../hooks/useFetch";

//Image
import NoImage from "../image/no-image.jpg";

const Home = () => {
    const { state, loading, error, searchTerm, setSearchTerm, setLoadMore } =
        useMoviesFetch();

    if (error) return <ErrorHandler error={true} />;
    return (
        <>
            {!searchTerm && state.results[0] ? (
                <HeroImage
                    image={`${IMAGE_BASE_URL}${BACKDROP_SIZE}${state.results[0].backdrop_path}`}
                    title={state.results[0].original_title}
                    text={state.results[0].overview}
                />
            ) : null}

            <SearchBar setSearchTerm={setSearchTerm} />

            <Grid header={searchTerm ? "Search Result" : "Popular Movies"}>
                {state.results.map(movie => (
                    <Thumb
                        key={movie.id}
                        movieId={movie.id}
                        clickable
                        image={
                            movie.poster_path
                                ? IMAGE_BASE_URL +
                                  POSTER_SIZE +
                                  movie.poster_path
                                : NoImage
                        }
                    />
                ))}
            </Grid>
            {loading && <Spinner />}
            {state.page < state.total_pages && !loading && (
                <Button text="Load More" callback={() => setLoadMore(true)} />
            )}
        </>
    );
};

export default Home;
